import { render, staticRenderFns } from "./footerCard.vue?vue&type=template&id=eaa74602&scoped=true"
import script from "./footerCard.vue?vue&type=script&lang=ts"
export * from "./footerCard.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./footerCard.vue?vue&type=style&index=0&id=eaa74602&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "eaa74602",
  "50ab5486"
  
)

export default component.exports